import { debug } from '../../../core/js/utils/logger';

import template from 'category-sort-menu.j2';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultSortQueryString } from '../utils/utils';

import { handleUtagEvent } from '../../../core/js/actions/initialActions.js';

import { interpolate } from '../../../core/js/filters/interpolate.js';

function attachEvents(store) {
    $(document).on('change', '.js-category-sort', function() {
        const state = store.getState();
        const isDefaultSortOption = $(this).find('option:selected').attr('data-is-default') === 'true';
        const qs = $(this).val().trim();
        const gaSlug = $(this).find('option:selected').attr('data-ga-slug');
        const gaCategory = _.get(state, 'core.pageType', _.get(state, 'core.constants.pageType'));

        const analyticsContainer = store.getState().core.localizations.containers.analyticsContainer;

        store.dispatch(handleUtagEvent({
            event_category: gaCategory,
            event_action: 'sort by',
            event_label: gaSlug
        }, 'link'));

        if (!isDefaultSortOption && qs) {
            window.location.search = `?${qs}`;
        } else {
            const defaultSortQueryString = getDefaultSortQueryString();

            if (defaultSortQueryString) {
                window.location.search = `?${defaultSortQueryString}`;
            } else {
                // remove '?' from URL (setting window.location.search keeps the '?')
                window.location.href = window.location.href.split('?')[0];
            }
        }
    });
}

function afterConstruction() {
    // Removing event and class on sorting selector:
    // this is used to allow for sorting before the category.js has loaded.
    // A change event for this selector is originally bound in:
    // /urbnweb/features/category/templates/category-shim.j2
    $('.js-enable-preload-sorting')
        .off()
        .removeClass('js-enable-preload-sorting');
}

export function onStateChange(store, watchValue, oldVal) {
    if (oldVal) {
        debug('Category: update sort');
        this.render(store, this, {});
    }
}

export function init(store, overrides = {}) {
    const config = {
        children: [],
        templateLocation: '.dom-category-sort',
        watch: 'category.sortOptions',
        name: 'sortComponent',
        attachEvents: attachEvents,
        afterConstruction: afterConstruction,
        onStateChange: onStateChange,
        template: template
    };

    return generate(config, store, overrides);
}
